var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"loading-modal","title":_vm.$t('STAY_REFRESH_HEADER'),"canClose":false}},[_c('div',{staticClass:"indicator"},[_c('div',{staticClass:"supporting"},[_vm._v(_vm._s(_vm.$t('STAY_REFRESH_SUPPORTING')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }